import { render, staticRenderFns } from "./bsp-tabs.vue?vue&type=template&id=9b39420e&"
import script from "./bsp-tabs.vue?vue&type=script&lang=js&"
export * from "./bsp-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports